// extracted by mini-css-extract-plugin
module.exports = {"search-input":"TopSearchBar_search-input__ZPvaU","icon":"TopSearchBar_icon__g-kzi"};